import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';

import 'iframe-resizer/js/iframeResizer.contentWindow';
import LegacyCardForm from './components/legacy/card/CardForm';
import LegacyBankAccountForm from './components/legacy/bankAccount/BankAccountForm';
import CardForm from './components/card/CardForm';
import BankAccountForm from './components/bankAccount/BankAccountForm';

function App() {
  return (
    <Router>
      <Routes>
        <Route path={'/'} element={<Navigate to="/card" />} />
        <Route path="/card" element={<LegacyCardForm />} />
        <Route path="/bank-account" element={<LegacyBankAccountForm />} />
        <Route path={'/v2'} element={<Navigate to="/v2/card" />} />
        <Route path="/v2/card" element={<CardForm />} />
        <Route path="/v2/bankAccount" element={<BankAccountForm />} />
      </Routes>
    </Router>
  );
}

export default App;
